const SET_ALERT_NOTIFICATION = 'SET_ALERT_NOTIFICATION';

const setAlertNotification = ({ alertNotification }) => ({
  payload: alertNotification,
  type: SET_ALERT_NOTIFICATION,
});

export { SET_ALERT_NOTIFICATION, setAlertNotification };
